import type { ReactNode } from 'react';
import { brand } from '@/config/brand';
import { env } from '@/config/env';
import { VScannerBanner } from './vscanner/VScannerBanner';
import { WafFreeAuthPanel } from './WafFreeAuthPanel';

/** Right-hand panel of the login / register pages. `undefined` = no panel. */
export function authBrandPanel(): ReactNode {
  if (env.isDev || env.vscannerBanner) return <VScannerBanner />;
  return brand.promos.wafFree ? <WafFreeAuthPanel /> : undefined;
}
